"use client";

import { Footer } from "@/app/components/Footer";
import { Image } from "@/app/components/Image";
import NavbarSnowsense from "@/app/components/NavbarSnowsense";
import { ArrowLink, Container, Eyebrow, HeroImage, RuleBlock, Section, SitePage } from "@/app/components/SiteUi";
import { useI18n } from "@/lib/i18n";

export default function Sjomaelar() {
	const { t } = useI18n();

	return (
		<SitePage>
			<NavbarSnowsense />
			<main>
				<Section theme="photo" className="h-[clamp(432px,calc(72px+(100vh-72px)*.55),692px)]">
					<HeroImage src="/pictures/sjomælir2.jpeg" origin="50% 50%" priority />
					<div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(10,14,28,.7)_0%,rgba(10,14,28,.25)_22%,rgba(0,0,0,.05)_50%,rgba(0,0,0,.55)_100%)]" />
					<div className="absolute inset-x-0 bottom-[clamp(36px,6vh,64px)]">
						<Container className="flex flex-col gap-3">
							<Eyebrow className="text-white/85">{t("sea_page.title")}</Eyebrow>
							<h1 className="text-[clamp(40px,5vw,72px)] font-bold leading-none tracking-[-0.02em] [text-shadow:0_2px_24px_rgba(0,0,0,.35)] text-balance">
								{t("sea_page.heading_about")}
								<span aria-hidden="true" className="mt-3 block h-[3px] w-16 rounded-full bg-white/80" />
							</h1>
						</Container>
					</div>
				</Section>

				<Section theme="light" className="py-[clamp(56px,8vh,96px)]">
					<Container>
						<div className="grid grid-cols-1 items-start gap-[clamp(32px,5vw,80px)] nav:grid-cols-[minmax(0,6fr)_minmax(0,6fr)]">
							<div className="flex flex-col self-start nav:sticky nav:top-[104px]">
								<RuleBlock className="self-start">
									<p className="max-w-[56ch] text-[clamp(20px,1.6vw,24px)] font-normal leading-[1.45] text-gray-700 text-pretty">
										{t("sea_page.body_about")}
									</p>
									<ArrowLink href="/sensors/kvi" className="mt-5 self-start">
										{t("sea_page.live_cta")}
									</ArrowLink>
								</RuleBlock>
							</div>
							<figure className="ml-auto w-[min(100%,520px)] min-[1600px]:w-[min(100%,560px)] max-nav:order-first max-nav:ml-0 max-nav:w-[min(100%,360px)]">
								<Image
									src="/pictures/sjom.jpeg"
									alt="Sea temperature sensor mounted on a fish farm pen"
									className="h-auto w-full rounded-lg shadow-[0_16px_40px_rgba(41,51,92,.12)]"
								/>
								<figcaption className="mt-3 text-[16px] italic text-gray-500">
									{t("sea_page.caption")}
								</figcaption>
							</figure>
						</div>
					</Container>
				</Section>

				<Section theme="tint" className="border-t border-gray-200 py-[clamp(56px,8vh,96px)]">
					<Container>
						<div className="grid grid-cols-[minmax(0,4fr)_minmax(0,8fr)] items-start gap-[clamp(32px,5vw,80px)] max-nav:grid-cols-1">
							<RuleBlock>
								<h2 className="text-[clamp(28px,2.8vw,42px)] font-bold leading-[1.1] tracking-[-0.015em] text-balance">
									{t("sea_page.heading_graphs")}
								</h2>
								<p className="text-[18px] text-gray-600 text-pretty">{t("sea_page.body_graphs")}</p>
							</RuleBlock>
							<div className="rounded-lg border border-gray-200 bg-white p-3 shadow-[0_12px_32px_rgba(41,51,92,.08)]">
								<Image
									src="/pictures/grof/sjo_graf.png"
									alt="Sea sensor chart showing temperature by depth"
									className="h-auto w-full"
								/>
							</div>
						</div>
					</Container>
				</Section>
			</main>
			<Footer />
		</SitePage>
	);
}
